import { render, staticRenderFns } from "./ArrowLeft.vue?vue&type=template&id=6d54a3b0&"
import script from "./ArrowLeft.vue?vue&type=script&lang=js&"
export * from "./ArrowLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports